<template>
	<div>
		<div class="wrapper-fluid bg-picture-darken">
			<!-- <div class="wrapper-fluid "> -->
			<Navigation />

			<router-view />

			<Footer></Footer>
		</div>
	</div>
</template>


<script>

import { mapGetters } from 'vuex'

export default {
	name: "PageReservation",
	mounted(){
		this.$store.dispatch('orm/reservation/START_NEW_RESERVATION')
		.catch(err => { this.$store.commit("core/ADD_ERROR", err); });

		this.$store.commit('orm/reservation/SET_NAVIGATION', true);
	},

	beforeDestroy(){
		this.$store.commit('orm/reservation/SET_NAVIGATION', false);
	},

}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageReservation.vue